import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing4,
  spacing24,
  spacing48,
} from 'approot/shared/styles/spacing.style';
import { grey1, grey5 } from 'approot/shared/styles/colours.style';
import { boxShadowBlack12 } from 'approot/shared/styles/borders.style';
import { PrimaryButton } from 'approot/shared/styles/buttons';

export const InteractiveResponseControlsRight = styled.div`
  position: absolute;
  margin-top: -${rem(47)};
  top: 50%;
  right: -${rem(spacing24)};
  z-index: 100;
`;

export const InteractiveResponseControlsBottom = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: -${rem(spacing24)};
`;

type InteractiveResponseControlProps = {
  $middle?: boolean;
  $right?: boolean;
};

export const InteractiveResponseControlsContainer = styled.div<InteractiveResponseControlProps>`
  position: absolute;
  left: ${({ $middle }) => $middle && '50%'};
  margin-left: ${({ $middle }) => $middle && rem(-spacing48)};
  right: ${({ $right }) => $right && rem(spacing24)};
`;

type InteractiveResponseControlsProps = {
  $vertical?: boolean;
};

export const InteractiveResponseControls = styled.div<InteractiveResponseControlsProps>`
  ${boxShadowBlack12}

  background-color: ${grey1};
  border: 1px solid ${grey5};
  border-radius: ${rem(80)};
  display: flex;
  flex-direction: ${({ $vertical = true }) => $vertical && 'column'};
  gap: ${rem(spacing4)};
  padding: ${rem(spacing4)};
`;

export const InteractiveResponseMobileNavControlsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const CheckAnswerButton = styled(PrimaryButton)`
  border-radius: ${rem(80)};
`;
